// extracted by mini-css-extract-plugin
module.exports = {"TempCmsData":"EditLessonWithContent_TempCmsData__2IsYF","NewCourse":"EditLessonWithContent_NewCourse__1a1A7"};